import { fetchAPI } from "@/lib/api";
import {
  responsiveImageFragment,
  sliderImageBgColorSelection,
} from "@/lib/fragments";

export const siteConfigurationQuery = `
siteConfiguration(filter: {configurationId: {eq: "${process.env.WEBSITE_CONFIG_ID}"}}, locale: $locale) {
    _allMetadataLocales {
      locale
    }
    id
    favicon {
      url
      width
      height
    }
    metadata {
      description
      title
    }
    shopifyUrl
    shopifyStorefrontAccessToken
      buttonConfig {
      __typename
    id
    useExternalUrl
    externalUrl
    buttonStyle
    useAnchor
    portfolioConfiguration {
      slug
      accoladesSlug
    }
    sectionAnchor {
    __typename
          ... on SectionQuoteRecord {
            id
            name

          }
          ... on SectionTextImageRecord {
            id
            title
      }
    }
    labelColor {
      name
      color {
        hex
      }
    }
    iconColor {
      name
      color {
        hex
        alpha
      }
    }
    icon {
      img {
        url
        width
        height
      }
    }
    addIcon
    linksToIframe
    iframeType
    buttonLabel {
      label
    }
    linksToProductAwardsPage
    linksToProductPage
    product {
      product{
        __typename
      slug
      id
      productTypeSpecific {
        __typename
        slug
      }
      }
      
    }
    page {
      ... on BrandsPageRecord {
        id
        slug
        title
      }
      ... on BrandsProductRecord {
        __typename
        id
        slug
      }
      ... on ArticleRecord {
        id
        slug
      }
      ... on BrandsPortfolioRecord {
        id
        title
        slug
      }
      ... on PageRecord {
        id
        title
        slug
      }
    }
    typeColor {
      name
      color {
        hex
      }
    }
      }
     geolocation {
       countryAvailability
                listOfCountries
                countries {
                  countryCode
                }
      }

    cartConfig {
      titleColor{
        color{
          hex
        }
      }
       textColor{
        color{
          hex
        }
      }
       backgroundColor{
        color{
          hex
        }
      }
       highlightColor{
        color{
          hex
        }
      }
    }
  
    configurationId
    metaPixelId
    microsoftClarityId
    gtmId
    googleAnalyticsId
    googleConsoleId
    cookieBotId
    websiteName
    errorFourOFourMessage
    errorFiveOOMessage
    errorTextColor{
      color{
        hex
      }
    }
    backgroundImage {
      id
      responsiveImage {
        ... responsiveImageFragment
      }
    }
    _seoMetaTags {
      tag
      content
      attributes
    }
    headerMenu {
      id
      title
      hasNav
      burgerMenuIcon {
        img {
          url
          width
          height
        }
      }
      closeMenuIcon {
        img {
          url
          width
          height
        }
      }
      items {
        id
        label
        externalLink
        externalUrl
        newWindow
        countryAvailability
        listOfCountries
        countries {
          title
          countryCode
        }
        linksToProductPage
        portfolioConfiguration {
          slug
        }
        product {
          product{
              __typename
            slug
            id
            productTypeSpecific {
              __typename
              slug
            }
          } 
        }
        link{
          ... on BrandsPortfolioRecord {
            __typename
            id
            slug
          }
          ... on BrandsProductRecord {
            __typename
            id
            slug
          }
          ... on BrandsPageRecord {
            __typename
            id
            slug
          }
        }
        subItems {
          id
          label
          externalLink
          externalUrl
          newWindow
          link {
            ... on BrandsPageRecord {
              __typename
              id
              slug
              title
            }
          }
        }
      }
      metaItems {
        slug
        label
        id
        externalLink
        externalUrl
        newWindow
        link {
          ... on BrandsLegalRecord {
            id
            title
            slug
          }
          ... on BrandsPageRecord {
            id
            slug
          }
        }
      }
      onlineShopLinks {
        __typename
        label
        link
        externalLink
        externalUrl
        newWindow
      }
      logo {
        title
        alt
        url
        width
        height
        responsiveImage {
          ...responsiveImageFragment
        }
      }
      logoRatio
      logoColour {
        title
        alt
        url
        width
        height
        responsiveImage {
          ...responsiveImageFragment
        }
      }

      mobileMenuBackgroundImage {
        url
        width
        height
      }
      mobileMenuBackgroundColor {
        color {
          hex
        }
      }
      desktopMenuBackgroudColor {
        color {
          hex
        }
      }
      desktopMenuItemsTextColor {
        color {
          hex
        }
      }
      menuTogglersColor {
        color {
          hex
        }
      }
      toggleAltLogoForMobile
      overwriteSocialIconsColor
      mobileMenuTextColor {
        color {
          hex
        }
      }
      logoAlignment
      navigationLinksAlignment
      headerMenuBarStyle
      addSocialLinks
    }
    footerMenu {
      id
      contestLabel {
        label
      }
      regulationFile {
        url
      }
      disclaimer {
        id
        label
      }
      addBuyCta
      ctaColor {
        color {
          hex
        }
      }
      ctaLabel {
        label
      }
      ctaLink
      countryAvailability
      listOfCountries
      countries {
        title
        countryCode
      }
      overwriteSocialIconsColor
      navigationLinksAlign
      addSpacer
      spacerType
      spacerLogo{
        url
        width
        height
      }
      textColor {
        hex
      }
      backgroundColor {
        hex
      }
      footerBackgroundColor {
        color {
          hex
        }
      }
      footerTextColor {
        color {
          hex
        }
      }
      hasNav
      hasSocial
      footerContent
      links {
        externalUrl
        externalLink
        newWindow
        slug
        image {
          title
          alt
          url
          width
          height
        }
      }
      navLinks {
        slug
        label
        externalLink
        externalUrl
        newWindow
        linksToProductPage
        portfolioConfiguration {
          slug
        }
        product {
          product {
            __typename
            slug
            id
            productTypeSpecific {
              __typename
              slug
            }
          }
        }
        link{ 
          ... on BrandsLegalRecord {
          id
          title
          slug
        }
        ... on BrandsPageRecord {
          id
          slug
        }
        ... on BrandsPortfolioRecord {
          __typename
          id
          slug
        }
        ... on BrandsProductRecord {
          __typename
          id
          slug
        }
       }
      }
      socialIconsDisplay
      socialLinks {
        slug
        label
        externalUrl
        newWindow
        swapImage
        image {
          url
          width
          height
        }
      }
    }
    logoPicker
    ageGateContent
    ageGateQuestion
    ageGateRedirectUrl
    ageGateBackgroundImage{
      url
      width
      height
    }
    backgroundType
    ageGateTitle
    backgroundGrColor {
      ${sliderImageBgColorSelection}
    }
    agBackgroundColor {
      color {
        hex
      }
    }
    agBodyColor {
      color {
        hex
      }
    }
    agHeadingColor {
      color {
        hex
      }
    }
    agTaglineColor {
      color {
        hex
      }
    }
    ageGateButton {
      ... on PageRelatedRecord {
        __typename
        id
        useExternalUrl
        externalUrl
        buttonStyle
        useAnchor
          sectionAnchor {
          __typename
                ... on SectionQuoteRecord {
                  id
                  name

                }
                ... on SectionTextImageRecord {
                  id
                  title
            }
          }
        labelColor {
          name
          color {
            hex
          }
        }
        iconColor {
          name
          color {
            hex
            alpha
          }
        }
        icon {
          img {
            url
            width
            height
          }
        }
        addIcon
        linksToIframe
        iframeType
        buttonLabel {
          label
        }
        linksToProductPage
        portfolioConfiguration {
          slug
        }
        product {
          product{
              __typename
            slug
            id
            productTypeSpecific {
              __typename
              slug
            }
          } 
        }
        page {
          ... on BrandsPageRecord {
            id
            slug
            title
          }
          ... on BrandsProductRecord {
            __typename
            id
            slug
          }
          ... on BrandsPortfolioRecord {
            id
            title
            slug
          }
          ... on PageRecord {
            id
            title
            slug
          }
        }
        typeColor {
          name
          color {
            hex
          }
        }
      }
    }
    addTitleUnderline
    underlineColor{
      color{
        hex
      }
    }
    customUnderlineAsset{
      img{
        url
        width
        height
      }
    }
    showFooter
    ageGateWelcome
}
`;

export async function getSiteConfiguration(locale, preview) {
  var siteId = 0;
  const data = await getSiteId()
    .then((config) => {
      siteId = config.id;
      return fetchAPI(
        `query Brand($locale: SiteLocale = ${process.env.DEFAULT_SITE_LOCALE}) {
          brandsPortfolio(filter: {siteConfig: {eq: "${config.id}"}}, locale: $locale) {
            id
            umbrellaBrands {
              id
            }
          }
        }`
      );
    })
    .then((brandPortfolio) => {
      return fetchAPI(
        `
            query siteConfiguration($locale: SiteLocale = ${process.env.DEFAULT_SITE_LOCALE}) {
              
              ${siteConfigurationQuery}

              brandsPortfolio(filter: {siteConfig: {eq: "${siteId}"}}) {
                id
                title
                umbrellaBrands {
                  id
                  title
                }
              }

            }
              ${responsiveImageFragment}
        `,
        {
          preview,
          variables: {
            locale,
          },
        }
      );
    });
  return data;
}

export async function getSiteId() {
  const data = await fetchAPI(
    `
      query siteConfiguration($locale: SiteLocale = ${process.env.DEFAULT_SITE_LOCALE}) { 
        siteConfiguration(filter: {configurationId: {eq: "${process.env.WEBSITE_CONFIG_ID}"}}, locale: $locale) {
          id
          configurationId
        }
      }
    `
  );
  return data?.siteConfiguration;
}
